module.exports = __webpack_public_path__ + "static/c7-cb0eeb7a416a9832e22eb95e80936cee.png";